import React from 'react'
import { connect } from 'react-redux'
import { colors } from '../../styles'
import styled from 'react-emotion'

const Message = styled('div')`
  border: 1px solid;
  margin: 10px 0;  
  padding: 15px;
  border-radius: 4px;
  background-color: ${props => props.error ? colors.error_bg : colors.tui_blue_25};
  border-color: ${props => props.error ? colors.error_border : colors.tui_dark_blue};
`

const Notification = ({ message, error, show }) => (
  show
    ? <Message error={error}>{message}</Message>
    : null
)

export default connect(
  (state, props) => ({
    message: state.notification.message,
    error: state.notification.error,
    show: state.notification.message
      ? state.notification.message && (props.id === state.notification.receiver || state.notification.receiver === '*')
      : false
  })
)(Notification)

